export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-1.1eb3f4d9.png";